import { styled, disabledProps } from "../../../styled-components";
import { RuntimeTheme } from "../../../lib/theme/theme";

export const CheckboxWrapper = styled.label<{ isEnabled: boolean; checked: boolean; singleItem: boolean }>`
    position: relative;

    ${p => !p.isEnabled && disabledProps};

    & > input {
        position: absolute;
        width: 0;
        height: 0;
    }

    display: flex;
    align-items: ${p => (p.singleItem ? "center" : "flex-start")};

    & > svg {
        min-width: 24px;
        color: ${p => (p.checked ? p.theme.primaryAccentColor : p.theme.fgColorMedium)};
    }

    padding: ${p => p.theme.componentInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

    .text-wrapper {
        margin-left: 12px;
    }

    .title {
        color: ${p => p.theme.fgColorDark};

        ${p => p.theme.fontStyles.Header4}
    }

    .description {
        color: ${p => p.theme.fgColorMedium};

        ${p => p.theme.fontStyles.Body5};
        margin-top: ${p => (p.singleItem ? 0 : 4)}px;
    }
`;

export const CheckedDrawing = (props: { theme: RuntimeTheme }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="2" fill="currentColor" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 17L5 12.1923L6.4 10.8462L10 14.3077L17.6 7L19 8.34615L10 17Z"
            fill={props.theme.accentForegroundColor}
        />
    </svg>
);

export const UncheckedDrawing = (_props: { theme: RuntimeTheme }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
            fill="currentColor"
        />
    </svg>
);
